import { vysionTrack } from './vysionService';

const setBillingVysion = (param: any): void => {
  switch (param.event) {
    case 'SOFORT FIRST NAME':
      vysionTrack(param, 'billing-sofort-firstName');
      break;
    case 'SOFORT LAST NAME':
      vysionTrack(param, 'billing-sofort-lastName');
      break;
    case 'SOFORT COUNTRY':
      vysionTrack(param, 'billing-sofort-country');
      break;
    default:
      return;
  }
};

export { setBillingVysion };
